export default __webpack_public_path__ + "static/media/miniplaneta.2215a132.png";